import { useNotificationStore } from '@/stores/notifications';

import { Notification } from './Notification';

export const Notifications = () => {
  const { notifications, dismissNotification } = useNotificationStore();

  return (
    <div
      id="notificationZone"
      aria-live="assertive"
      className="z-[999999] flex flex-col-reverse lg:flex-col fixed inset-0 space-y-4 items-center px-4 pt-0 lg:pt-2.5 pb-10 lg:pb-0 pointer-events-none"
    >
      {notifications.map((notification) => {
        return (
          <Notification
            key={notification.id}
            notification={notification}
            onDismiss={dismissNotification}
          />
        );
      })}
    </div>
  );
};
